var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditLinePencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.3333H14M11 2.33333C11.2652 2.06812 11.6249 1.91912 12 1.91912C12.1857 1.91912 12.3696 1.9557 12.5412 2.02677C12.7128 2.09784 12.8687 2.20201 13 2.33333C13.1313 2.46466 13.2355 2.62056 13.3066 2.79214C13.3776 2.96372 13.4142 3.14762 13.4142 3.33333C13.4142 3.51905 13.3776 3.70295 13.3066 3.87453C13.2355 4.04611 13.1313 4.20201 13 4.33333L4.66667 12.6667L2 13.3333L2.66667 10.6667L11 2.33333Z",
    stroke: "#09090B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLinePencil);
export default __webpack_public_path__ + "static/media/edit-line-pencil.1666830a9075fb6b7199832f18b7bed6.svg";
export { ForwardRef as ReactComponent };